import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QrCodeService } from '../../../../core/services/qr-input-service/qr-input.service';
import { GlobalConstants } from '../../../../common/constants/global.constant';

@Component({
  selector: 'app-panther-lake-details-page',
  templateUrl: './panther-lake-details-page.component.html',
  styleUrls: ['./panther-lake-details-page.component.scss']
})
export class PantherLakeDetailsPageComponent implements OnInit {

  @Input() panelData;
  detailsPageName: string;
  isPantherLakeStd: boolean = false;
  isPantherLake12Xe: boolean = false;
  dynamicClassName: string;
  setIntelDisplayOneFont: boolean = false;
  isTileDetailPanel: boolean = false;
  nonItalicLangArray = ['ar-sa','he','ja','ko','th','zh-cn','zh-tw'];
  language: string;

  constructor(
   private router: ActivatedRoute,
   private qrCodeService: QrCodeService,
  ) { }

  ngOnInit(): void {
    this.detailsPageName = this.router.snapshot.params.facttagname;
    this.isPantherLakeStd = this.qrCodeService.isPantherLakeStd;
    this.isPantherLake12Xe = this.qrCodeService.isPantherLake12Xe;
    this.dynamicClassName = this.detailsPageName;
    if (this.isPantherLake12Xe) {
      this.dynamicClassName = this.dynamicClassName.replace('ptl', 'ptl12xe');
    }
    if(this.detailsPageName === 'ptl-softwarebundle'){
      if(GlobalConstants.PANTHER_LAKE_12XE_BADGES.includes(this.qrCodeService.qrInput.ProcessorBadge)){
        this.panelData[0].tileDetails.tr_title1 = this.panelData[0].tileDetails?.tr_title1.replace(GlobalConstants.XX, GlobalConstants.PANTHER_LAKE_BADGES_FAMILY_MAPPING[this.qrCodeService.qrInput.ProcessorBadge]);
        this.panelData[0].tileDetails.tr_subtitle = this.panelData[0].tileDetails?.tr_subtitle.replace(GlobalConstants.XX, GlobalConstants.PANTHER_LAKE_BADGES_FAMILY_MAPPING[this.qrCodeService.qrInput.ProcessorBadge]);
        this.panelData[0].tileDetails.badgeUrl = this.panelData[0].tileDetails?.badgeUrl.replace(GlobalConstants.XX, GlobalConstants.PANTHER_LAKE_BADGES_FAMILY_MAPPING[this.qrCodeService.qrInput.ProcessorBadge]);
      }
    }
    this.setIntelDisplayOneFont = this.qrCodeService.setenusLang();
    const qrData = this.qrCodeService?.getQrData();
    this.language = qrData.Language;
    this.setPTLandXEPanelData();
  }

  setPTLandXEPanelData() {
    if (this.isPantherLake12Xe) {
      this.isTileDetailPanel = GlobalConstants.PTL_12XE_DDP_PAGES.includes(this.detailsPageName);
    }
    else {
      this.isTileDetailPanel = GlobalConstants.PTL_DDP_PAGES.includes(this.detailsPageName);
    }
  }
}
